import { MARQUEE_WORDS } from "@/data/site";

// Slow editorial marquee — pure CSS animation, seamless loop.
export default function Marquee() {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-slate-200 bg-white py-6 select-none"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap will-change-transform animate-[marquee_38s_linear_infinite] hover:[animation-play-state:paused]">
        {items.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8 font-display text-2xl md:text-4xl font-semibold text-[#0A192F]/85">
              {word}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-[#F97316]" />
          </span>
        ))}
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
    </div>
  );
}
